export default {
    data:() => ({
        chatClick: false,
        agentInfo: {},
        defaultAgent:{
            'agentName': process.env.VUE_APP_QAGENTNAME,
            'agentPreferredName': process.env.VUE_APP_QAGENTNAME,
            'agencyName': process.env.VUE_APP_QAGENCYNAME,
            'agentPhone': process.env.VUE_APP_QAGENTPHONE,
            'agentBPhone': process.env.VUE_APP_QAGENTBPHONE,
            'agentEmail': process.env.VUE_APP_QAGENTEMAIL,
            'agentPayrollID': process.env.VUE_APP_QAGENTPAYROLL,
            'agentGovtId': process.env.VUE_APP_QAGENTID,
            'agentAddress': process.env.VUE_APP_QAGENTADDRESS,
            'agentCity': process.env.VUE_APP_QAGENTCITY,
            'agentState': process.env.VUE_APP_QAGENTSTATE,
            'agentZip': process.env.VUE_APP_QAGENTZIP,
            'agentCode': process.env.VUE_APP_QAGENTCODE,
            'agentFirstName': process.env.VUE_APP_QAGENTFIRSTNAME,
            'agentLastName': process.env.VUE_APP_QAGENTLASTNAME,
            'amam_writingNumbers': null,
            'Signature': null,
            'agentLicenses': ['CA','AK','AL','AR','AZ','CO','CT','DC',
                'DE','FL','GA','HI','IA','ID','IL','IN','KS','KY','LA','MA',
                'MD','ME','MI','MN','MO','MS','MT','NC','ND','NE','NH','NJ','NM',
                'NV','NY','OH','OK','OR','PA','PR','RI','SC','SD','TN','TX','UT',
                'VA','VT','WA','WI','WV','WY'],
            'AffiliateCode': null,
        },
        defaultOCAgent:{
            'agentName': process.env.VUE_APP_OCAGENTNAME,
            'agentPreferredName': process.env.VUE_APP_OCAGENTNAME,
            'agencyName': process.env.VUE_APP_OCAGENCYNAME,
            'agentPhone': process.env.VUE_APP_OCAGENTPHONE,
            'agentBPhone': process.env.VUE_APP_OCAGENTBPHONE,
            'agentEmail': process.env.VUE_APP_OCAGENTEMAIL,
            'agentPayrollID': process.env.VUE_APP_OCAGENTPAYROLL,
            'AgentID': process.env.VUE_APP_OCAGENTID,
            'agentAddress': process.env.VUE_APP_OCAGENTADDRESS,
            'agentCity': process.env.VUE_APP_OCAGENTCITY,
            'agentState': process.env.VUE_APP_OCAGENTSTATE,
            'agentZip': process.env.VUE_APP_OCAGENTZIP,
            'agentCode': process.env.VUE_APP_OCAGENTCODE,
            'agentFirstName': process.env.VUE_APP_OCAGENTFIRSTNAME,
            'agentLastName': process.env.VUE_APP_OCAGENTLASTNAME,
            'amam_writingNumbers': {
                'Occidental': '0000079768',
                'amam':'0000105370'
            },
            'Signature': null,
            'OCDTCAvatar': null,
            'agentLicenses': ['NC','AK','AL','AR','AZ','CA','CO','CT','DC',
                'DE','FL','GA','HI','IA','ID','IL','IN','KS','KY','LA','MA',
                'MD','ME','MI','MN','MO','MS','MT','ND','NE','NH','NJ','NM',
                'NV','NY','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT',
                'VA','VT','WA','WI','WV','WY'],
            'AffiliateCode': null,
        },
        jh_card_info:{
            logo: 'John-Hancock_Carrier-Logos.svg',
            messages: [
                'Rewards and discounts for living a healthy life',
                'Instant decision and coverage'
            ],
            method: 'gotoEapp'
        },
        chat_card_info:{
            logo: 'Conversation-Quote-Icon-WG.svg',
            messages: [
                'Lifetime support for all your policy needs',
                'Free virtual or in-person consults',
                'Licensed agents shop from 80+ insurance companies to find your best price!'
            ],
        },
        lga_card_info:{
            logo: 'BannerLife_Logo_Black_325x143.svg',
            messages: [
                'Coverage up to $2 million',
                'Terminal, Chronic and Critical Illness',
                'Fast, digital application with no exams',
            ],
            method: 'gotoEapp'
        },
        rules: {
            required: value => !!value || 'Required.',
            dob: v => (!!v === true) && !isNaN(Date.parse(v)) || 'Enter a valid date (MM/DD/YYYY).',
            zipcode: v => (!!v === true) && Number.isInteger(Number(v)) && Number(v) < 99999 && (v !== null && v.length == 5) || 'Enter a valid zip code',
            phone: v => {
                if(!!v === false){
                    return 'Enter a valid phone number (XXX-XXX-XXXX).'
                }
                const p = v.replace(/[^\d.]/g, '')
                return (Number.isInteger(Number(p)) && p.length == 10) || 'Enter a valid phone number (XXX-XXX-XXXX).'
            },
            email: v => {
                if(!!v === false){
                    return 'Enter a valid email address.'
                }

                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(v) || 'Enter a valid email address.'
            },
            covLimit: v => {
                let max = '$2,000,000'
                let maxNum = 2000000

                if(this?.age >= 61 && this?.age <= 65){
                    max = '$250,000'
                    maxNum = 250000
                } else if (this?.age >= 51 && this?.age <= 50) {
                    max = '$500,000'
                    maxNum = 500000
                }

                if(!!v === false){
                    return `Please enter an amount between $25,000 and ${max}.`
                }

                if((typeof v) == 'number'){
                    v = v.toString()
                }

                const n = Number(v.replace(/[^\d.-]/g, ''))
                return (!!v === true) && (n <= maxNum && n >= 100000) || `Please enter an amount between $100,000 and ${max}.`
            },
        },
    }),
    methods: {
        async getAgentInfo(site) {
            const ste_url = process.env.VUE_APP_PROXY + 'get-agent-detail';
            const parameters = this.$route.params;

            if(site === 'QUILITY') {
                this.agentInfo = this.getDefaultQuilityAgent();
                return this.agentInfo;
            }

            // console.log(`Brandons code: ${process.env.VUE_APP_PERSONAL_CODE}`, `current agent code:${parameters.agent_code}`)
            if(this.isPersonalCheck(parameters.agent_code)) {
                const res = await this.getPersonalAgent(parameters.agent_code)
                return res
            }

            try {
                let res = await fetch(ste_url,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*'
                    },
                    body: JSON.stringify({'agent_code':parameters.agent_code}),
                })
                let json_data = await res.json()
                const a_data = json_data.data

                if(typeof a_data == 'undefined' || a_data.AgentName === '') {
                    return this.getDefaultOCAgent(parameters.agent_code);
                }

                return {
                    'agentName': a_data.AgentName,
                    'agentPreferredName': a_data.AgentPreferredName,
                    'agentFirstName': a_data.FirstName,
                    'agentLastName': a_data.LastName,
                    'agencyName': a_data.AgencyName,
                    'agentPhone': a_data.AgentPhone,
                    'agentEmail': a_data.AgentEmail,
                    'agentPayrollID': a_data.JHWritingNumber,
                    'AgentID': a_data.AgentID,
                    'agentAddress': a_data.AddressLine1,
                    'agentCity': a_data.City,
                    'agentState': a_data.State,
                    'agentZip': a_data.Zip,
                    'agentCode': a_data.AgentCode,
                    'agentLicenses': a_data.licensedStates,
                    'amam_writingNumbers': a_data.amam,
                    'Signature': a_data.Signature,
                    'HasOCDTCSubscription': a_data.HasOCDTCSubscription,
                    'OCDTCAvatar': a_data.OCDTCAvatar,
                    'AffiliateCode': a_data.AffiliateCode,
                    'C': a_data.C,
                    'SB': a_data.SB,
                    'HatchCalendarUrl': a_data.HatchCalendarUrl,
                }

            } catch (error) {
                console.error(error);
                this.agentInfo = this.getDefaultOCAgent(parameters.agent_code);
                return this.agentInfo;
            }
        },

        getDefaultQuilityAgent() {
            return {
                'agentName': process.env.VUE_APP_QAGENTNAME,
                'agentPreferredName': process.env.VUE_APP_QAGENTNAME,
                'agencyName': process.env.VUE_APP_QAGENCYNAME,
                'agentPhone': process.env.VUE_APP_QAGENTPHONE,
                'agentBPhone': process.env.VUE_APP_QAGENTBPHONE,
                'agentEmail': process.env.VUE_APP_QAGENTEMAIL,
                'agentPayrollID': process.env.VUE_APP_QAGENTPAYROLL,
                'agentGovtId': process.env.VUE_APP_QAGENTID,
                'agentAddress': process.env.VUE_APP_QAGENTADDRESS,
                'agentCity': process.env.VUE_APP_QAGENTCITY,
                'agentState': process.env.VUE_APP_QAGENTSTATE,
                'agentZip': process.env.VUE_APP_QAGENTZIP,
                'agentCode': process.env.VUE_APP_QAGENTCODE,
                'agentFirstName': process.env.VUE_APP_QAGENTFIRSTNAME,
                'agentLastName': process.env.VUE_APP_QAGENTLASTNAME,
                'amam_writingNumbers': null,
                'Signature': null,
                'agentLicenses': ['CA','AK','AL','AR','AZ','CO','CT','DC',
                    'DE','FL','GA','HI','IA','ID','IL','IN','KS','KY','LA','MA',
                    'MD','ME','MI','MN','MO','MS','MT','NC','ND','NE','NH','NJ','NM',
                    'NV','NY','OH','OK','OR','PA','PR','RI','SC','SD','TN','TX','UT',
                    'VA','VT','WA','WI','WV','WY'],
                'AffiliateCode': null,
                'C': {
                    'SBLI': true,
                    'JH': true
                }
            }
        },

        getDefaultOCAgent() {
            return {
                'agentName': process.env.VUE_APP_OCAGENTNAME,
                'agentPreferredName': process.env.VUE_APP_OCAGENTNAME,
                'agencyName': process.env.VUE_APP_OCAGENCYNAME,
                'agentPhone': process.env.VUE_APP_OCAGENTPHONE,
                'agentBPhone': process.env.VUE_APP_OCAGENTBPHONE,
                'agentEmail': process.env.VUE_APP_OCAGENTEMAIL,
                'agentPayrollID': process.env.VUE_APP_OCAGENTPAYROLL,
                'AgentID': process.env.VUE_APP_OCAGENTID,
                'agentAddress': process.env.VUE_APP_OCAGENTADDRESS,
                'agentCity': process.env.VUE_APP_OCAGENTCITY,
                'agentState': process.env.VUE_APP_OCAGENTSTATE,
                'agentZip': process.env.VUE_APP_OCAGENTZIP,
                'agentCode': process.env.VUE_APP_OCAGENTCODE,
                'agentFirstName': process.env.VUE_APP_OCAGENTFIRSTNAME,
                'agentLastName': process.env.VUE_APP_OCAGENTLASTNAME,
                'amam_writingNumbers': {
                    'Occidental': '0000079768',
                    'amam':'0000105370'
                },
                'Signature': null,
                'OCDTCAvatar': null,
                'agentLicenses': ['NC','AK','AL','AR','AZ','CA','CO','CT','DC',
                    'DE','FL','GA','HI','IA','ID','IL','IN','KS','KY','LA','MA',
                    'MD','ME','MI','MN','MO','MS','MT','ND','NE','NH','NJ','NM',
                    'NV','NY','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT',
                    'VA','VT','WA','WI','WV','WY'],
                'AffiliateCode': null,
                'C': {
                    'SBLI': true,
                    'JH': true
                }
            }
        },

        logEvent(category, label, action) {
            if (typeof gtag == 'function') {
                gtag('event', action, {'event_category': category,'event_label': label,});  // eslint-disable-line
            }
        },

        logFBConversion(category, label, action) {
            try {
                if (typeof fbq == 'function') {
                    fbq('track', action, {'content_category': category,'content_type': label,}); // eslint-disable-line
                }
            } catch (err) {
                // console.log("whooppsie fb : " + err.message);
            }
        },

        logBingConversion(category, label, action) {
            try {
                window.uetq = window.uetq || [];
                if (typeof window.uetq == 'object') {
                    action = action.replace(' ', '_');
                    label = label.replace(' ', '_');
                    category = category.replace(' ', '_');
                    window.uetq.push('event', action, {
                        'event_category': category,
                        'event_label': label,
                        'event_value': 1
                    });
                }
            } catch (err) {
                // console.log("whooppsie bing: " + err.message);
            }
        },

        isPersonalCheck(agentCode) {
            return agentCode == process.env.VUE_APP_PERSONAL_CODE
        },

        async getPersonalAgent() {
            let agent = this.getDefaultOCAgent()
            let hqAgentData = await this.getPersonalHQData() // used to get the signature and headshot urls

            agent.agentName = process.env.VUE_APP_PERSONAL_FULL_NAME
            agent.agentPreferredName = process.env.VUE_APP_PERSONAL_FULL_NAME
            agent.agentEmail = process.env.VUE_APP_PERSONAL_EMAIL
            agent.agentCode = process.env.VUE_APP_PERSONAL_CODE
            agent.agentFirstName = process.env.VUE_APP_PERSONAL_FIRST_NAME
            agent.agentLastName = process.env.VUE_APP_PERSONAL_LAST_NAME
            agent.amam_writingNumbers = {
                'Occidental': process.env.VUE_APP_PERSONAL_OCCIDENTAL,
                'amam': process.env.VUE_APP_PERSONAL_AMAM
            }
            agent.agentPhone = null
            agent.Signature = hqAgentData.Signature ? hqAgentData.Signature : process.env.VUE_APP_PERSONAL_SIGNATURE
            agent.OCDTCAvatar = hqAgentData.OCDTCAvatar ? hqAgentData.OCDTCAvatar : null

            return agent
        },

        async getAgentSignatureLink(agentCode) {
            agentCode = (agentCode == process.env.VUE_APP_PERSONAL_CODE) ? process.env.VUE_APP_OCAGENTCODE : agentCode
            const ste_url = process.env.VUE_APP_PROXY + 'get-agent-detail';

            try {
                let res = await fetch(ste_url,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*'
                    },
                    body: JSON.stringify({'agent_code':agentCode}),
                })
                let json_data = await res.json()

                if(typeof json_data.data == 'undefined' || json_data.data.AgentName === '') {
                    return null
                }
                return json_data.data.Signature
            } catch (error) {
                console.error(error)
                return null
            }
        },

        async getPersonalHQData() {
            const ste_url = process.env.VUE_APP_PROXY + 'get-agent-detail';

            try {
                let res = await fetch(ste_url,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*'
                    },
                    body: JSON.stringify({'agent_code':process.env.VUE_APP_OCAGENTCODE}),
                })
                let json_data = await res.json()
                return json_data.data
            } catch (error) {
                // console.log(error)
                return null
            }
        },

        date_diff_days(s, e){
            var start = new Date(s);
            var end = new Date(e);
            var days = (end - start) / 1000 / 60 / 60 / 24;
            days = days - (end.getTimezoneOffset() - start.getTimezoneOffset()) / (60 * 24)

            return days
        },

        calculateAge(bd) {
            const currentDate = new Date();
            const currentYear = currentDate.getFullYear();
            const currentMonth = currentDate.getMonth();
            const currentDay = currentDate.getDate();

            let calculatedAge = currentYear - bd.getFullYear();

            if (currentMonth < bd.getMonth() - 1) {
                calculatedAge--;
            }

            if (bd.getMonth() - 1 == currentMonth && currentDay < bd.getDate()) {
                calculatedAge--;
            }
            return calculatedAge;
        },

        formatNumber(maximumFractionDigits, minimumFractionDigits, n){
            let fc = new Intl.NumberFormat('en-IN', { maximumFractionDigits, minimumFractionDigits })
            let dfc = new Intl.NumberFormat()
            return (maximumFractionDigits > 0 || minimumFractionDigits > 0) ? fc.format(n) : dfc.format(n)
        },

        formatCurrency(a, maxDigits = 0) {
            let fc = new Intl.NumberFormat(undefined, {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: maxDigits,
            })
            return fc.format(a)
        },

        async routeToCESC() {
            let rerouted = false

            try {
                const payload = {
                    Product_Type: this.form.product_type,
                    Lead_Subtype: this.quoteData.leadSubType ?? null,
                    First_Name: this.form.first_name,
                    Last_Name: this.form.last_name,
                    Phone: this.form.phone_number,
                    Plan: this.form.coverage_plan,
                    Coverage_Amount: this.form.coverage_amount,
                    Premium_Frequency: 'Monthly',
                    Nicotine_User: this.form.tobacco_used,
                    Premium_Quoted_Amount: this.quoteData.premium ?? 0,
                    City: this.form.city,
                    State: this.form.state_id,
                    Zip_Code: this.form.zip_code,
                    Email: this.form.email,
                    Street: null,
                    County: this.form.county,
                    DOB: this.form.dob_formatted,
                    Gender: this.form.gender,
                    Age: this.form.age,
                    Lead_Source: null,
                    zoho_id: this.zohoid,
                }
                const api_url = process.env.VUE_APP_PROXY + 'reroute-lead'
                let res = await fetch(api_url,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*'
                    },
                    body: JSON.stringify(payload),
                })
                let json_data = await res.json()

                rerouted = json_data.success
                if(rerouted === false){
                    console.error('routToCESC', json_data.message)
                }
            } catch (error) {
                console.error('routToCESC', error)
            }

            return rerouted
        },

        async routeToSwitchboardOC() {
            let rerouted = false

            try {
                const payload = {
                    Product_Type: this.form.product_type,
                    First_Name: this.form.first_name,
                    Last_Name: this.form.last_name,
                    Phone: this.form.phone_number,
                    Plan: this.form.coverage_plan,
                    Coverage_Amount: this.form.coverage_amount,
                    Premium_Frequency: 'Monthly',
                    Nicotine_User: this.form.tobacco_used,
                    Premium_Quoted_Amount: this.quoteData.premium ?? 0,
                    Agent_Code: this.agent.agentCode,
                    City: this.form.city,
                    State: this.form.state_id,
                    County: this.form.county_name,
                    Zip: this.form.zip_code,
                    Email: this.form.email,
                    Sex: this.form.gender,
                    Birthday: this.form.dob_formatted,
                    Age: this.form.age,
                    MetaData: {
                        OC_DTC_RAQ_FORM_DATA: this.form,
                        // ZOHO_ID: this.zohoid,
                        QUOTE_DATA: this.quoteData.quotes ?? null,
                    }
                }
                const api_url = process.env.VUE_APP_PROXY + 'reroute-lead-OC'
                let res = await fetch(api_url,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*'
                    },
                    body: JSON.stringify(payload),
                })
                let json_data = await res.json()

                rerouted = json_data.success
                if(rerouted === false){
                    console.error('routeToSwitchboardOC -> msg', json_data.message)
                    console.error('routeToSwitchboardOC -> data', json_data)
                }
            } catch (error) {
                console.error('routeToSwitchboardOC', error)
            }

            return rerouted
        },

        async FindAdvisor() {
            let rerouted = false

            if(this.site == 'OC'){
                try {
                    if(this.isset(this.agent.HatchCalendarUrl)){
                        await this.$split_client.delete()
                        window.location.href = this.agent.HatchCalendarUrl
                    } else {
                        rerouted = await this.routeToSwitchboardOC()
                    }
                } catch (error) {
                    console.error(error)
                    rerouted = await this.routeToSwitchboardOC()
                }
            } else {
                rerouted = await this.routeToCESC()
            }

            if(rerouted){
                const parameters = this.$route.params;

                if(parameters.site === 'OC') {
                    window.location.href = parameters.oc_redirect_url
                }

                this.$store.commit('updateForwardCesc', true)
                this.$router.push({name: 'Thankyou'});
            }
        },

        getImgUrl(pic) {
            return require('../assets/'+pic)
        },

        stripNonNumbericChars(n){
            if(n === null || n === undefined){
                return null
            }

            // remove non-numeric values and decimal values
            let covAmt = n.replace(/[^\d.-]/g, '')

            covAmt = new Intl.NumberFormat('en-US').format(covAmt)

            return (covAmt == "" || covAmt == "0") ? null : `$${covAmt}`
        },

        isset(...vars) {
            for (let i = 0;i < vars.length;i++) {
                if (typeof vars[i] === 'undefined' || vars[i] === null) {
                    return false;
                }
            }
            return true;
        },

        async launchQLT(){

            let client = await this.$split_client.latest
            const qlt_data = this.quoteData.quotes.find(q => q.Carrier === "SBLI")

            const lead_info = {
                'premium': qlt_data.Premium,
                'zoho_id': this.zohoid,
                'product': 'Quility Level Term',
                'disposition': 'RAQ Apply Now'
            }

            try {
                const phone = this.form.phone_number
                let phone_clean = phone.replace('(', '')
                phone_clean = phone_clean.replace(')', '')

                const d = new Date(this.form.dob)
                let dob_m = '' + (d.getMonth() + 1)
                let dob_d = '' + d.getDate()
                let dob_y = d.getFullYear()

                if(dob_m.length < 2){
                    dob_m = '0' + dob_m
                }

                if(dob_d.length < 2){
                    dob_d = '0' + dob_d
                }

                const postParam = {
                    email: this.form.email,
                    leadReferenceId: this.zohoid,
                    phone: phone_clean,
                    zip: this.form.zip_code,
                    firstname: this.form.first_name,
                    lastname: this.form.last_name,
                    dob: `${dob_y}-${dob_m}-${dob_d}`,
                    gender: this.form.gender,
                    state: this.form.state_id,
                    coverage: this.form.coverage_amount,
                    term: this.form.coverage_plan,
                    smoker: this.form.tobacco_used,
                    arcId: qlt_data.arcId,
                    agentCode: (this.site === 'OC') ? this.agent.agentCode : process.env.VUE_APP_QLTCORPAGENT,
                    AffiliateCode: this.agent.AffiliateCode,
                }

                let ste_url = process.env.VUE_APP_PROXY + 'get-sbli-url';

                try {
                    let res = await fetch(ste_url,{
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Access-Control-Allow-Origin': '*'
                        },
                        body: JSON.stringify(postParam),
                    })
                    let json_data = await res.json()

                    if (json_data.success == false) {
                        lead_info['disposition'] = 'Quote Error';
                        this.eApp_dialog = false
                        return false
                    }

                    client.track('anonymous', 'form.eapp.start')
                    if(this.site === 'OC'){
                        client.track('anonymous', 'form.eapp.ocdtc.qlt.start')
                    } else {
                        client.track('anonymous', 'form.eapp.qlt.start')
                    }
                    // kill split instance
                    await this.$split_client.delete()

                    window.location.href = json_data.data.redirectUrl
                } catch (error) {
                    // kill split instance
                    await this.$split_client.delete()

                    console.error('multiplequotes->process_sbli->error', error)
                }
            } catch (error) {
                console.error('multiplequotes->process_sbli->error', error)
                this.error_dialogue = true
                this.eApp_dialog = false
            }
        },

        async launchJH(){
            let client = await this.$split_client.latest
            const jh_data = this.quoteData.quotes.find(q => q.Carrier === "John Hancock")

            // console.log('jh data', jh_data)

            this.$store.commit('updateEnteringEApp', true)
            this.$store.commit('updateSelectedProduct', 'JH')
            this.eApp_dialog = true;
            const phone_clean = this.form.phone_number.replace('(','').replace(')','')

            const d = new Date(this.form.dob)
            let dob_m = '' + (d.getMonth() + 1)
            let dob_d = '' + d.getDate()
            let dob_y = d.getFullYear()

            if(dob_m.length < 2){
                dob_m = '0' + dob_m
            }

            if(dob_d.length < 2){
                dob_d = '0' + dob_d
            }

            const param_premium = this.formatNumber(2,2, jh_data.Premium)
            const queryParam = {
                firstName: this.form.first_name,
                lastName: this.form.last_name,
                dob: `${dob_m}-${dob_d}-${dob_y}`,
                gender: this.form.gender,
                state: this.form.state_id,
                phone: phone_clean,
                coverageAmount: new Intl.NumberFormat().format(this.form.coverage_amount),
                coverageLength: this.form.coverage_plan.substring(0, 2),
                smoker: this.form.tobacco_used === 'Yes' ? 'Smoker' : 'NonSmoker',
                healthClass: 'Excellent',
                estimateMonthly: param_premium,
                email: this.form.email,
                applicantId: this.zohoid,
                salesSource: 'ain',
                salesSourceVariation: 'quility',
                productType: 'lft',
                agentEmail: this.agent.agentEmail,
                agentId: this.agent.agentGovtId ?? null,
                agentLicense: this.agent.agentLicenses,
                agentLicenseState: this.form.state_id,
                agentName: this.agent.agentName,
                agentPhone: this.agent.agentPhone,
                agentAddress: this.agent.agentAddress,
                agentCity: this.agent.agentCity,
                agentState: this.agent.agentState,
                agentZip: this.agent.agentZip,
                agentPayrollID: this.agent.agentPayrollID,
                customSkin: 'quility',
                quility_site: (this.site === 'OC') ? 'oc' : 'quility',
                token: process.env.VUE_APP_JH_TOKEN,
            }

            let query_string = Object.keys(queryParam).map(function(key) {
                return key + '=' + queryParam[key]
            }).join('&')

            const redirect_url = process.env.VUE_APP_JH_EAPP_URL + 'processor/intake?' + query_string

            try {
                client.track('anonymous', 'form.eapp.start')
                if(this.site === 'OC'){
                    client.track('anonymous', 'form.eapp.ocdtc.jh.start')
                } else {
                    client.track('anonymous', 'form.eapp.jh.start')
                }
                // kill split instance
                await this.$split_client.delete()

                window.location.href = redirect_url
            } catch (error) {
                // kill split instance
                await this.$split_client.delete()

                console.error('jhQuoteCard->gotoEapp->error',error)
                this.error_dialogue = true
                this.eApp_dialog = false
            }
        },
        // yes I stole this from Stack Overflow
        // no I don't feel bad about it
        getMonthsBetween(date1,date2,roundUpFractionalMonths)
        {
            //Months will be calculated between start and end dates.
            //Make sure start date is less than end date.
            //But remember if the difference should be negative.
            var startDate=date1;
            var endDate=date2;
            var inverse=false;
            if(date1>date2)
            {
                startDate=date2;
                endDate=date1;
                inverse=true;
            }

            //Calculate the differences between the start and end dates
            var yearsDifference=endDate.getFullYear()-startDate.getFullYear();
            var monthsDifference=endDate.getMonth()-startDate.getMonth();
            var daysDifference=endDate.getDate()-startDate.getDate();

            var monthCorrection=0;
            //If roundUpFractionalMonths is true, check if an extra month needs to be added from rounding up.
            //The difference is done by ceiling (round up), e.g. 3 months and 1 day will be 4 months.
            if(roundUpFractionalMonths===true && daysDifference>0)
            {
                monthCorrection=1;
            }
            //If the day difference between the 2 months is negative, the last month is not a whole month.
            else if(roundUpFractionalMonths!==true && daysDifference<0)
            {
                monthCorrection=-1;
            }

            return (inverse?-1:1)*(yearsDifference*12+monthsDifference+monthCorrection);
        },

        getLeadTypeFromQueryParam() {
            // OC-1391 Fix: Use Vue Router query for hash mode URLs
            const leadType = this.$route.query.leadtype || this.$route.query.leadType;
            return leadType;
        },

        getProductTypeFromQueryParam() {
            // OC-1391 Fix: Use Vue Router query for hash mode URLs
            const productType = this.$route.query.producttype || this.$route.query.productType;
            
            if (productType && productType.trim() !== '') {
                return productType;
            }
            
            return this.form.product_type === 'Mortgage Protection' ? 'MP' : 'TL';
        },

        async routeOCToQLM(dtcNotEligible = false){
            let rerouted = false
            let externalPartnerId = null

            try {
                const leadType = this.getLeadTypeFromQueryParam();
                const productType = this.getProductTypeFromQueryParam();

                const payload = {
                    'AgentCode': this.agent.agentCode,
                    'Zipcode': this.form.zip_code,
                    'City': this.form.city,
                    'Email': this.form.email,
                    'State': this.form.state_id,
                    'FirstName': this.form.first_name,
                    'LastName': this.form.last_name,
                    'ProductType': productType,
                    'Referrer': this.redirectUrl ?? (this.$cookies.get('set_referring_url')) ? this.$cookies.get('set_referring_url') : document.referrer,
                    'DOB': this.form.dob_formatted,
                    'Phone': this.form.phone_number,
                    'LeadSource': leadType || this.form.lead_type,
                    'UtmSource': this.$cookies.get('utm_source'),
                    'Form': this.form,
                    'HatchInstance': this.isOCSite,
                    'DtcNotEligible': dtcNotEligible
                }
                const api_url = process.env.VUE_APP_PROXY + 'route-oc-qlm'
                let res = await fetch(api_url,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Access-Control-Allow-Origin': '*'
                    },
                    body: JSON.stringify(payload),
                })
                let json_data = await res.json()

                console.log('routeOCToQLM', JSON.stringify(json_data));
                rerouted = json_data.success
                // OC-1509: Capture External Partner ID from Lead Depot response
                if (json_data.externalPartnerId) {
                    externalPartnerId = json_data.externalPartnerId
                }
            } catch (error) {
                console.error('routeOCToQLM', error)
            }

            this.$store.commit('updateLeadRouted', rerouted)
            // OC-1509: Return both success status and external partner ID
            return { success: rerouted, externalPartnerId: externalPartnerId }
        },

        // OC-1509: Store unlicensed DTC case tracking data
        async storeHatchCaseTracking(caseId, externalPartnerId, agentCode) {
            try {
                const payload = {
                    case_id: caseId,
                    external_partner_id: externalPartnerId,
                    agent_code: agentCode
                }

                const api_url = process.env.VUE_APP_PROXY + 'store-unlicensed-dtc-case'
                let res = await fetch(api_url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Access-Control-Allow-Origin': '*'
                    },
                    body: JSON.stringify(payload),
                })
                let json_data = await res.json()

                if (json_data.success) {
                    console.log('Case tracking data stored successfully')
                    return true
                } else {
                    console.error('Failed to store case tracking data:', JSON.stringify(json_data));
                    return false
                }
            } catch (error) {
                console.error('storeHatchCaseTracking error', error)
                return false
            }
        },

        setCoverageItems(min=25000, max=2000000) {

            const r = []
            let amt = min

            while(amt <= max){
                r.unshift({
                    'text': this.formatCurrency(amt),
                    'value': amt
                })

                amt += 25000
            }
            // console.log('setCoverageItems', {min, max, r})
            return r;
        },

        setTermLengths(age){
            const newPlans = []

            if(age <= 40){
                newPlans.unshift({text: '40 Years', value: '40 Years'})
            }

            if(age <= 45) {
                newPlans.unshift({text: '35 Years', value: '35 Years'})
            }

            if(age <= 50) {
                newPlans.unshift({text: '30 Years', value: '30 Years'})
            }

            if(age <= 55) {
                newPlans.unshift({text: '25 Years', value: '25 Years'})
            }

            if(age <= 60) {
                newPlans.unshift({text: '20 Years', value: '20 Years'})
                newPlans.unshift({text: '15 Years', value: '15 Years'})
            }

            if(age <= 65) {
                newPlans.unshift({text: '10 Years', value: '10 Years'})
            }

            return newPlans
        }
    },
    computed: {
        agent(){
            return this.$store.state.agent
        },
        form(){
            return this.$store.state.form
        },
        site(){
            return this.$store.state.site
        },
        zohoid(){
            return this.$store.state.zoho_id
        },
        isMobile(){
            return this.$vuetify.breakpoint.mobile
        },
        quoteData(){
            return this.$store.state.quote_data
        },
        fetchingQuote(){
            return this.$store.state.fetching_quote
        },
        enteringEApp(){
            return this.$store.state.entering_e_app
        },
        forwardCesc(){
            return this.$store.state.forward_cesc
        },
        redirectUrl(){
            return this.$store.state.redirect_url
        },
        treatments(){
            return this.$store.state.treatments
        },
        isQuotePage() {
            return this.$route.path === '/quotes'
        },
        cov_amount_treatment() {
            return this.treatments.cov_amount.value
        },
        mma_cta_treatment() {
            return this.treatments.mma_cta.value
        },
        mma_cta_configs() {
            return this.treatments.mma_cta.configs
        },
        isOCSite() {
            return this.site === 'OC'
        },
        tky() {
            return this.$store.state.TRCKERYGAMBLESWITLiesHppnessAdEDstnytse
        },
        showChat() {
            return this.$store.state.showChat
        },
        otp_treatment() {
            return this.treatments.otp.value
        },
        selectedProduct() {
            return this.$store.state.selected_product
        },
        quoteParams() {
            return this.$store.state.quote_params
        },
        ts_treatment() {
            return this.treatments.ts.value
        },
        main_frequency() {
            return this.freq_treatment ? 'daily' : 'monthly'
        },
        secondary_frequency() {
            return this.freq_treatment ? 'monthly' : 'daily'
        },
        amp_event_data() {
            let {
                    age,
                    city,
                    county_name,
                    coverage_amount, coverage_plan,
                    dob,
                    dob_formatted,
                    email,
                    first_name,
                    gender,
                    last_name,
                    lead_type,
                    phone_number,
                    product_type,
                    spanish_speaking,
                    state_id,
                    tobacco_used,
                    zip_code
                } = this.form

            let jhData = this.quoteData.quotes.find(q => q.Carrier === "John Hancock")
            let sbliData = this.quoteData.quotes.find(q => q.Carrier === "SBLI")

            return {
                age,
                city,
                county_name,
                coverage_amount,
                coverage_plan,
                dob,
                dob_formatted,
                email,
                first_name,
                gender,
                last_name,
                lead_type,
                phone_number,
                product_type,
                spanish_speaking,
                state_id,
                tobacco_used,
                zip_code,
                quote_qlt_carrier: sbliData?.Carrier ?? null,
                quote_qlt_coverage: sbliData?.Coverage ?? null,
                quote_qlt_frequency: sbliData?.Mode ?? null,
                quote_qlt_product: sbliData?.Product ?? null,
                quote_qlt_term: sbliData?.term ?? null,
                quote_jh_carrier: jhData?.Carrier ?? null,
                quote_jh_coverage: jhData?.Coverage ?? null,
                quote_jh_frequency: jhData?.Mode ?? null,
                quote_jh_product: jhData?.Product ?? null,
                quote_jh_term: jhData?.Term ?? null,
            }

        },
        freq_treatment() {
            return this.treatments.freq.value
        },
        lead_routed() {
            return this.$store.state.lead_routed
        }
    }
};
